var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"_copyright-text cell medium-6 xlarge-4"},[_vm._v(" Copyright © "+_vm._s(_vm.copyrightYear)+" Budsies LLC ")])])}
var staticRenderFns = []

export { render, staticRenderFns }